import ReactDOM from 'react-dom/client';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'tailwindcss/tailwind.css';
import 'react-tooltip/dist/react-tooltip.css';

import './index.css';
import * as Sentry from '@sentry/react';
import App from './App';
import reportWebVitals from './reportWebVitals';

Sentry.init({
  dsn:
    import.meta.env.NODE_ENV === 'production'
      ? 'https://bb43e1e40cbd33cc4a9f52db69916da8@o432100.ingest.us.sentry.io/4509390198800384'
      : undefined,
  // Performance Monitoring
  tracesSampleRate: 0.5, // Capture 100% of the conversations
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

dayjs.locale('fr');
dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
